import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '..'

const InEligiCreditCategories = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 28 28"
    fill="none"
    {...props}
  >
    <Path
      d="M27.18 7.959H.82a.82.82 0 0 0-.82.82v9.607a2.577 2.577 0 0 0 2.578 2.578h22.844A2.577 2.577 0 0 0 28 18.386V8.779a.82.82 0 0 0-.82-.82Z"
      fill="#94BFFF"
    />
    <Path
      d="M28 18.386V8.779a.82.82 0 0 0-.82-.82h-8.787v13.005h7.03A2.577 2.577 0 0 0 28 18.386Z"
      fill="#69A6FF"
    />
    <Path
      d="M27.18 6.085H.82a.82.82 0 0 1-.82-.82v-.937A2.577 2.577 0 0 1 2.578 1.75h22.844A2.577 2.577 0 0 1 28 4.328v.937a.82.82 0 0 1-.82.82Z"
      fill="#94BFFF"
    />
    <Path
      d="M28 5.265v-.937c0-1.44-1.17-2.578-2.578-2.578h-7.029v4.335h8.787a.82.82 0 0 0 .82-.82Z"
      fill="#69A6FF"
    />
    <Path d="M0 5.265h28v3.514H0V5.265Z" fill="#1F539E" />
    <Path d="M18.393 5.265H28v3.514h-9.607V5.265Z" fill="#0E2A52" />
    <Path
      d="M7.85 17.449H6.091a2.577 2.577 0 1 1 0-5.155H7.85a2.577 2.577 0 1 1 0 5.155Z"
      fill="#F0F7FB"
    />
    <Path
      d="M25.437 26.25H11.35a2.57 2.57 0 0 1-2.22-1.282 2.572 2.572 0 0 1 0-2.563l7.043-12.2a2.57 2.57 0 0 1 2.22-1.282 2.57 2.57 0 0 1 2.22 1.282l7.044 12.2c.456.79.456 1.772 0 2.563a2.57 2.57 0 0 1-2.22 1.282Z"
      fill="#fff"
    />
    <Path
      d="M27.657 24.968a2.572 2.572 0 0 0 0-2.563l-7.044-12.2a2.57 2.57 0 0 0-2.22-1.282V26.25h7.044c.913 0 1.763-.491 2.22-1.282Z"
      fill="#fff"
    />
    <Path
      d="M11.35 24.61a.925.925 0 0 1-.8-.462.926.926 0 0 1 0-.923l7.044-12.2a.925.925 0 0 1 .8-.46c.328 0 .634.176.798.46l7.044 12.2a.927.927 0 0 1 0 .923.926.926 0 0 1-.8.461H11.35Z"
      fill="#FF9595"
    />
    <Path
      d="M26.236 24.148a.926.926 0 0 0 0-.923l-7.044-12.2a.926.926 0 0 0-.799-.46v14.044h7.044a.925.925 0 0 0 .799-.46Z"
      fill="#F46262"
    />
    <Path
      d="M18.393 22.736a.82.82 0 0 1-.82-.82v-.44a.82.82 0 1 1 1.64 0v.44a.82.82 0 0 1-.82.82Z"
      fill="#fff"
    />
    <Path
      d="M19.214 21.915v-.439a.82.82 0 0 0-.82-.82v2.08a.82.82 0 0 0 .82-.82Z"
      fill="#FFE7E7"
    />
    <Path
      d="M18.393 19.22a.82.82 0 0 1-.82-.82v-3.37a.82.82 0 0 1 1.64 0v3.37a.82.82 0 0 1-.82.82Z"
      fill="#fff"
    />
    <Path
      d="M19.214 18.4v-3.37a.82.82 0 0 0-.82-.82v5.01a.82.82 0 0 0 .82-.82Z"
      fill="#FFE7E7"
    />
  </Svg>
)

export default InEligiCreditCategories
